"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Geolocation = require("./Geolocation");
Object.keys(_Geolocation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Geolocation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Geolocation[key];
    }
  });
});